import React from 'react';

const ChartLegendText: React.FC<React.PropsWithChildren> = ({ children }) => (
  <div className="text-teacher-blue uppercase text-[10px] md:text-xs font-bold flex-1 text-center">{children}</div>
);

export default ChartLegendText;
